export default __webpack_public_path__ + "static/media/html.6cd4f7e9.svg";